import CrossIcon from '@atlaskit/icon/glyph/cross';
import DocumentsIcon from '@atlaskit/icon/glyph/documents';
import { usePrivacySecurityAnalytics } from '@atlassian/mpac-analytics';
import { LinkWithIcon } from '@atlassian/mpac-primitives';
import { MarketplacePartnerType } from '@atlassian/mpac-types/graphql-gateway-types';
import * as React from 'react';
import { ANALYTICS_EVENT_CONTAINER_OVERVIEW_TAB, ANALYTICS_OVERVIEW_PRIVACY_POLICY_UI_LINK } from '../../constants';
import { InfoListItem, InfoListItemContent, InfoListItemIcon, ItemDescription } from '../styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PrivacyPolicy = props => {
  const {
    privacyPolicyUrl,
    partnerType
  } = props;
  const {
    fireLinkEvent
  } = usePrivacySecurityAnalytics();
  const onPrivacyPolicyLinkClick = linkText => {
    fireLinkEvent(ANALYTICS_OVERVIEW_PRIVACY_POLICY_UI_LINK, {
      source: ANALYTICS_EVENT_CONTAINER_OVERVIEW_TAB,
      linkText
    });
  };
  if (privacyPolicyUrl) {
    if (partnerType === MarketplacePartnerType.AtlassianInternal) {
      return /*#__PURE__*/_jsxs(InfoListItem, {
        children: [/*#__PURE__*/_jsx(InfoListItemIcon, {
          children: /*#__PURE__*/_jsx(DocumentsIcon, {
            label: "Atlassian privacy policy",
            size: "medium"
          })
        }), /*#__PURE__*/_jsxs(InfoListItemContent, {
          children: [/*#__PURE__*/_jsx(ItemDescription, {
            children: "Atlassian's privacy policy is applicable to the use of this app."
          }), /*#__PURE__*/_jsx(LinkWithIcon, {
            href: privacyPolicyUrl,
            type: "external",
            size: "medium",
            onClick: () => onPrivacyPolicyLinkClick('Atlassian privacy policy'),
            children: "Atlassian privacy policy"
          })]
        })]
      });
    }
    return /*#__PURE__*/_jsxs(InfoListItem, {
      children: [/*#__PURE__*/_jsx(InfoListItemIcon, {
        children: /*#__PURE__*/_jsx(DocumentsIcon, {
          label: "",
          size: "medium"
        })
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(ItemDescription, {
          children: "Atlassian's privacy policy is not applicable to the use of this app. Please refer to the privacy policy provided by this app's partner."
        }), /*#__PURE__*/_jsx(LinkWithIcon, {
          href: privacyPolicyUrl,
          type: "external",
          size: "medium",
          onClick: () => onPrivacyPolicyLinkClick('Partner privacy policy'),
          children: "Partner privacy policy"
        })]
      })]
    });
  }
  return /*#__PURE__*/_jsxs(InfoListItem, {
    children: [/*#__PURE__*/_jsx(InfoListItemIcon, {
      children: /*#__PURE__*/_jsx(CrossIcon, {
        label: "Privacy policy unspecified",
        size: "medium"
      })
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(ItemDescription, {
        children: "Atlassian's privacy policy is not applicable to the use of this app. This app's partner has not provided a privacy policy. Please contact the partner directly for their privacy policy."
      })
    })]
  });
};